import React from "react";
import { Skeleton } from "@mui/material";
import { HiChevronDown } from "react-icons/hi2";

const FiltersSkeleton = () => {
    return (
        <ul className="py-3 px-2 flex flex-col gap-2 w-full">
            {Array.from({ length: 4 }).map((_, idx) => (
                <li key={idx} className="flex items-center gap-2">
                    <span className="w-5/6">
                        <Skeleton height={7} />
                    </span>{" "}
                    <HiChevronDown />
                </li>
            ))}
        </ul>
    );
};

export default FiltersSkeleton;
